module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/patch-ea3469aa66f8a7c9702ee7259dff4125.svg";